import React from 'react';
import djLogo from '../media/djs-logo.png';

// Funnel positions at or past "Contract Signed" - the point where a DJ gets
// their social media assets.
const SOSHA_STATUSES = ['Contract Signed', 'Assignment Matched', 'Assignment Confirmed', 'Paid'];

const Header = ({dj, electionStatus}) => {
  return (
    <header className="max-w-7xl mx-auto px-4 sm:px-2 lg:px-8 py-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex justify-start">
          <img
            src={djLogo}
            alt="DJ Logo"
            className="w-20 h-20 rounded-full object-cover"
          />
        </div>
        
        <div className="ml-auto flex max-w-full flex-col items-end gap-2 sm:flex-row sm:gap-3">
          
          {/* Resources Button - Glass effect with underline animation */}
          {/* Only shown to DJs who have been hired for an election. */}
          {dj?.hired_for_election_status && (
          <a
              href="https://djsatthepolls.org/djs2026/#essentials"
            target="_blank"
            rel="noreferrer"
            className="group relative inline-flex w-auto max-w-full items-center justify-center whitespace-nowrap rounded-full border border-gray-300 bg-white bg-opacity-20 px-3.5 py-2 text-sm font-medium text-gray-800 backdrop-filter backdrop-blur-lg transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:px-4"
            style={{ 
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#333',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
              outline: '1.5px solid #3966C3'
            }}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 flex-shrink-0 transform transition-transform duration-300 group-hover:rotate-12" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" 
                clipRule="evenodd" 
              />
            </svg>
            <span className="relative">
                DJ Essentials
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 ease-out group-hover:w-full"></span>
            </span>
          </a>
          )}

          {/* Social Media Button - Glass effect with underline animation */}
          {dj?.sosha_link && SOSHA_STATUSES.includes(electionStatus) && (
            <a 
              href={dj.sosha_link}
              rel="noreferrer"
              target="_blank" 
              className="group inline-flex items-center justify-center w-36 sm:w-40 px-3.5 sm:px-4 py-2 sm:py-2 rounded-full bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg border border-gray-300 text-gray-800 text-sm font-medium transition-all duration-300 ease-in-out hover:shadow-md hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 whitespace-nowrap relative overflow-hidden"
              style={{ 
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#333',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                outline: '1.5px solid #3966C3'
              }}
            >
              <svg 
                width="200" 
                height="200" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24"
                className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 flex-shrink-0 transform transition-transform duration-300 group-hover:rotate-12"
                fill="currentColor"
              >
                <path 
                  fill="#000000" 
                  fillRule="evenodd" 
                  d="M13.5 4.5a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0M8 4.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0m-2.75-2a2 2 0 1 0 0 4a2 2 0 0 0 0-4m2.763 7.038A3.25 3.25 0 0 0 2 11.25v4.25a.5.5 0 0 0 .5.5H7v2a.5.5 0 0 0 .5.5H12v4a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a5 5 0 0 0-8.25-3.8a3.5 3.5 0 0 0-5.737-1.162" 
                  clipRule="evenodd"
                />
              </svg>
              <span className="relative">
              Post to social
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 ease-out group-hover:w-full"></span>
              </span>
            </a>
          )}
          {/* Social Media Button - Glass effect with underline animation */}
          {/* <a 
            href="#" 
            className="group inline-flex items-center justify-center w-36 sm:w-40 px-3.5 sm:px-4 py-2 sm:py-2 rounded-full bg-white bg-opacity-20 backdrop-filter backdrop-blur-lg border border-white border-opacity-20 text-gray-800 text-sm font-medium transition-all duration-300 ease-in-out hover:shadow-md hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 whitespace-nowrap relative overflow-hidden"
            style={{ 
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#333',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
            }}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 flex-shrink-0 transform transition-transform duration-300 group-hover:rotate-12" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z" 
                clipRule="evenodd" 
              />
            </svg>
            <span className="relative">
              Social Media
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gray-800 transition-all duration-300 ease-out group-hover:w-full"></span>
            </span>
          </a>
          */}
        </div>
      </div>
    </header>
  );
};

export default Header;
